module.exports = __webpack_public_path__ + "assets/img/Travel_Cirendini.6aa32dda-ps.jpg";